__turbopack_context__.v({
  "popoverContent": "index-module__RL7qsq__popoverContent",
  "popoverOverlay": "index-module__RL7qsq__popoverOverlay",
});
